

// import React, { useEffect, useState, useRef, useMemo } from "react";
// import Grid from "@mui/material/Grid";
// import CircularProgress from "@mui/material/CircularProgress";
// import MDBox from "components/MDBox";
// import Card from "@mui/material/Card";
// import MDTypography from "components/MDTypography";
// import { Typography } from "@mui/material";
// import EntityCard from "examples/Cards/EntityCard";
// import ADSearch from "components/ADSearch";
// import EntityService from "services/entity-service";
// import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
// import { styled } from "@mui/material/styles";
// import IconButton from "@mui/material/IconButton";
// import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
// import ADDateRange from "components/ADDateRange";
// import dayjs from "dayjs";
// import utc from "dayjs/plugin/utc";
// import timezone from "dayjs/plugin/timezone";
// import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
// import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
// import Grow from "@mui/material/Grow";


// dayjs.extend(utc);
// dayjs.extend(timezone);
// dayjs.extend(isSameOrAfter);
// dayjs.extend(isSameOrBefore);

// function SelectEntity({ profile, selectedEntities = [], onSelect }) {
//   const [entities, setEntities] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [searchQuery, setSearchQuery] = useState("");

//   const tz = dayjs.tz.guess();
//   const [dateRange, setDateRange] = useState([
//     dayjs().tz(tz).subtract(7, "day").startOf("day"),
//     dayjs().tz(tz).endOf("day"),
//   ]);

//   const handleDateChange = ([start, end]) => {
//     setDateRange([
//       start ? dayjs(start).tz(tz).startOf("day") : null,
//       end ? dayjs(end).tz(tz).endOf("day") : null,
//     ]);
//   };

//   const [toolbarTop, setToolbarTop] = useState(() => {
//     const width = window.innerWidth;
//     if (width < 600) return 260;
//     if (width < 770) return 195;
//     return 210;
//   });

//   const [isTransparent, setIsTransparent] = useState(true);

//   const imageHeightsRef = useRef([]);
//   const [heightCalculationDone, setHeightCalculationDone] = useState(false);

//   const registerHeight = (height) => {
//     imageHeightsRef.current.push(Math.round(height));
//     if (imageHeightsRef.current.length === filteredEntities.length) {
//       setHeightCalculationDone(true);
//     }
//   };

//   useEffect(() => {
//     const handleResizeOrScroll = () => {
//       const scrollY = window.scrollY;
//       setIsTransparent(scrollY === 0);

//       const width = window.innerWidth;
//       let newTop;

//       if (width < 600) {
//         newTop = scrollY > 10 ? 240 : 260;
//       } else if (width < 770) {
//         newTop = scrollY > 10 ? 200 : 195;
//       } else {
//         newTop = scrollY > 10 ? 155 : 210;
//       }

//       setToolbarTop(newTop);
//     };

//     window.addEventListener("resize", handleResizeOrScroll);
//     window.addEventListener("scroll", handleResizeOrScroll);
//     handleResizeOrScroll();

//     return () => {
//       window.removeEventListener("resize", handleResizeOrScroll);
//       window.removeEventListener("scroll", handleResizeOrScroll);
//     };
//   }, []);

//   const CustomTooltip = styled(({ className, ...props }) => (
//     <Tooltip {...props} classes={{ popper: className }} />
//   ))({
//     [`& .${tooltipClasses.tooltip}`]: {
//       maxWidth: 400,
//       textAlign: "left",
//     },
//   });

//   const tooltipContent = (
//     <div style={{ maxWidth: "350px", textAlign: "left" }}>
//       <Typography variant="body2" gutterBottom>
//         <strong>How to Use Entity Selector:</strong>
//       </Typography>
//       <Typography variant="caption" display="block" gutterBottom>
//         - Browse through entities (e.g., <strong>posts</strong>, <strong>videos</strong>) fetched from the selected profile.<br />
//         - Select one or more entities for snapshot generation or comparison.<br />
//         - Click “Continue” to proceed after making your selection.
//       </Typography>
//       <Typography variant="body2" gutterBottom>
//         <strong>Quick Tips:</strong>
//       </Typography>
//       <Typography variant="caption" display="block">
//         - Use the search bar to filter by message, title, or description.<br />
//         - Hover over cards to preview highlights and click to select/deselect.<br />
//       </Typography>
//     </div>
//   );

//   const getEntityId = (entity) => entity?.postId || entity?.videoId || entity?.id || "";

//   const isSelected = (entityId) => selectedEntities.some((p) => p.entityId === entityId);

//   const toggleSelection = (entity) => {
//     const entityId = getEntityId(entity);
//     const alreadySelected = isSelected(entityId);

//     const normalizedEntity = {
//       ...entity,
//       entityId,
//     };

//     if (alreadySelected) {
//       const updated = selectedEntities.filter((p) => getEntityId(p) !== entityId);
//       onSelect(updated);
//     } else {
//       onSelect([...selectedEntities, normalizedEntity]);
//     }
//   };

//   useEffect(() => {
//     const fetchEntities = async () => {
//       if (!profile?.id || !profile?.platform) return;
//       setLoading(true);

//       const [fromDate, toDate] = dateRange;
//       const formattedFromDate = dayjs(fromDate).startOf("day").toISOString();
//       const formattedToDate = dayjs(toDate).add(1, "day").startOf("day").toISOString();

//       try {
//         const response = await EntityService.fetchEntity(
//           profile.platform,
//           formattedFromDate,
//           formattedToDate,
//           [],
//           profile.id
//         );

//         const rawEntities = Array.isArray(response) ? response : [response];

//         const validEntities = rawEntities.filter((entity) => {
//           if (["Facebook", "Instagram"].includes(profile.platform)) {
//             return Array.isArray(entity.posts) && entity.posts.length > 0;
//           } else if (profile.platform === "YouTube") {
//             return Array.isArray(entity.videos) && entity.videos.length > 0;
//           }
//           return false;
//         });

//         setEntities(validEntities);
//         setHeightCalculationDone(false);
//         imageHeightsRef.current = [];
//       } catch (error) {
//         console.error("Failed to fetch entities:", error);
//         setEntities([]);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchEntities();
//   }, [profile, dateRange]);

//   const [fromDate, toDate] = dateRange;
//   const contentField = profile.platform === "YouTube" ? "videos" : "posts";

//   const filteredEntities = entities
//     .flatMap((entity) => (Array.isArray(entity[contentField]) ? entity[contentField] : []))
//     .filter((item) => {
//       const createdTime = item.created_time || item.publishedAt || item.taken_at;
//       if (!createdTime) return false;
//       const localTime = dayjs(createdTime);
//       return (
//         localTime.isSameOrAfter(dayjs(fromDate).startOf("day")) &&
//         localTime.isSameOrBefore(dayjs(toDate).endOf("day")) &&
//         (item.message || item.caption || item.title || "").toLowerCase().includes(searchQuery.toLowerCase())
//       );
//     })
//     .sort((a, b) => new Date(b.created_time || b.publishedAt || b.taken_at) - new Date(a.created_time || a.publishedAt || a.taken_at));

//   const forcedHeight = useMemo(() => {
//     if (!heightCalculationDone) return null;
//     const counts = {};
//     imageHeightsRef.current.forEach((h) => {
//       counts[h] = (counts[h] || 0) + 1;
//     });
//     const sorted = Object.entries(counts).sort((a, b) => b[1] - a[1]);
//     const MAX_ALLOWED_HEIGHT = 300; // px

//     return sorted.length > 0
//       ? Math.min(Number(sorted[0][0]), MAX_ALLOWED_HEIGHT)
//       : null;

//   }, [heightCalculationDone]);

//   return (
//     <MDBox>
//       <MDBox
//         display="flex"
//         justifyContent="space-between"
//         alignItems="center"
//         sx={{
//           position: "sticky",
//           top: `${toolbarTop}px`,
//           zIndex: 999,
//           backgroundColor: "#ffffff",
//           padding: "5px",
//           borderRadius: "8px",
//           gap: 2,
//           mb: 5,
//           boxShadow: isTransparent ? "none" : "0 4px 12px rgba(0, 0, 0, 0.2)",
//           transition: "top 0.9s ease, background-color 0.9s ease, box-shadow 0.9s ease",
//         }}
//       >
//         <ADSearch searchQuery={searchQuery} setSearchQuery={setSearchQuery} placeholder="Filter content by caption..." />
//         <ADDateRange onDateChange={handleDateChange} />
//       </MDBox>

//       <Card sx={{ height: "calc(100vh - 310px)", display: "flex", flexDirection: "column" }}>
//         <MDBox
//           mx={2}
//           mt={-3}
//           py={1}
//           px={2}
//           variant="gradient"
//           bgColor="info"
//           borderRadius="lg"
//           coloredShadow="info"
//           display="flex"
//           flexDirection="row"
//           alignItems="center"
//         >
//           <MDTypography variant="h6" color="white">
//             {`Your ${profile.platform === "YouTube" ? "Videos" : "Posts"}`}
//           </MDTypography>
//           <CustomTooltip title={tooltipContent} placement="bottom" arrow>
//             <IconButton sx={{ color: "white", p: 0, ml: 0.5 }}>
//               <InfoOutlinedIcon fontSize="small" />
//             </IconButton>
//           </CustomTooltip>
//         </MDBox>

//         <MDBox px={2} py={3} sx={{ flexGrow: 1, overflowY: "auto" }}>
//           {loading ? (
//             <MDBox display="flex" justifyContent="center" alignItems="center" p={3}>
//               <CircularProgress color="info" />
//             </MDBox>
//           ) : filteredEntities.length === 0 ? (
//             <MDTypography variant="subtitle1" color="text" align="center">
//               No entities found for this profile.
//             </MDTypography>
//           ) : (
//             <MDBox display="flex" flexWrap="wrap" justifyContent="center" gap={2} px={2} mt={0.5}>
//               {filteredEntities.map((entity, index) => {
//                 const id = getEntityId(entity);
//                 const type = profile.platform === "YouTube" ? "video" : "post";

//                 return (
//                   <Grow
//                     in={true}
//                     timeout={index * 100}
//                     key={id}
//                     style={{ transformOrigin: "0 0 0" }}
//                   >
//                     <MDBox
//                       sx={{ flex: "1 1 calc(20% - 16px)", minWidth: "280px", maxWidth: "300px" }}
//                     >
//                       <EntityCard
//                         entityObject={entity}
//                         platform={profile.platform}
//                         entityType={type}
//                         profileObject={profile}
//                         isSelected={isSelected(id)}
//                         onSelect={() => toggleSelection(entity)}
//                         forcedHeight={forcedHeight}
//                         registerHeight={registerHeight}
//                       />
//                     </MDBox>
//                   </Grow>
//                 );
//               })}

//             </MDBox>
//           )}
//         </MDBox>
//       </Card>
//     </MDBox>
//   );
// }

// export default SelectEntity;



// ###########################################




import React, { useEffect, useState, useRef, useMemo } from "react";
import Grid from "@mui/material/Grid";
import CircularProgress from "@mui/material/CircularProgress";
import MDBox from "components/MDBox";
import Card from "@mui/material/Card";
import MDTypography from "components/MDTypography";
import { Typography } from "@mui/material";
import EntityCard from "examples/Cards/EntityCard";
import ADSearch from "components/ADSearch";
import EntityService from "services/entity-service";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import ADDateRange from "components/ADDateRange";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import Grow from "@mui/material/Grow";


dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

function SelectEntity({ profile, selectedEntities = [], onSelect }) {
  const [entities, setEntities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");

  const [toolbarTop, setToolbarTop] = useState(210);

  const tz = dayjs.tz.guess();
  const [dateRange, setDateRange] = useState([
    dayjs().tz(tz).subtract(7, "day").startOf("day"),
    dayjs().tz(tz).endOf("day"),
  ]);

  const handleDateChange = ([start, end]) => {
    setDateRange([
      start ? dayjs(start).tz(tz).startOf("day") : null,
      end ? dayjs(end).tz(tz).endOf("day") : null,
    ]);
  };

  const [isTransparent, setIsTransparent] = useState(true);

  const imageHeightsRef = useRef([]);
  const [heightCalculationDone, setHeightCalculationDone] = useState(false);

  const registerHeight = (height) => {
    imageHeightsRef.current.push(Math.round(height));
    if (imageHeightsRef.current.length === filteredEntities.length) {
      setHeightCalculationDone(true);
    }
  };

  useEffect(() => {
    const updateToolbarTop = () => {
      const navbar = document.querySelector("header.MuiAppBar-root");
      const stepper = document.querySelector(".MuiStepper-root");
      if (navbar && stepper) {
        // same logic as in MarketSnapshot
        const navHeight = navbar.offsetHeight;
        const stepperHeight = stepper.offsetHeight;
        const totalTop = navHeight + stepperHeight + 8;
        setToolbarTop(totalTop);
      } else if (navbar) {
        setToolbarTop(navbar.offsetHeight + 60);
      }
    };

    updateToolbarTop();

    const resizeObserver = new ResizeObserver(updateToolbarTop);
    resizeObserver.observe(document.body);

    const scrollHandler = () => setIsTransparent(window.scrollY === 0);
    window.addEventListener("resize", updateToolbarTop);
    window.addEventListener("scroll", scrollHandler);

    return () => {
      resizeObserver.disconnect();
      window.removeEventListener("resize", updateToolbarTop);
      window.removeEventListener("scroll", scrollHandler);
    };
  }, []);

  const CustomTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))({
    [`& .${tooltipClasses.tooltip}`]: {
      maxWidth: 400,
      textAlign: "left",
    },
  });

  const tooltipContent = (
    <div style={{ maxWidth: "350px", textAlign: "left" }}>
      <Typography variant="body2" gutterBottom>
        <strong>How to Use Entity Selector:</strong>
      </Typography>
      <Typography variant="caption" display="block" gutterBottom>
        - Browse through entities (e.g., <strong>posts</strong>, <strong>videos</strong>) fetched from the selected profile.<br />
        - Select one or more entities for snapshot generation or comparison.<br />
        - Click “Continue” to proceed after making your selection.
      </Typography>
      <Typography variant="body2" gutterBottom>
        <strong>Quick Tips:</strong>
      </Typography>
      <Typography variant="caption" display="block">
        - Use the search bar to filter by message, title, or description.<br />
        - Hover over cards to preview highlights and click to select/deselect.<br />
      </Typography>
    </div>
  );

  const getEntityId = (entity) => entity?.postId || entity?.videoId || entity?.id || "";

  const isSelected = (entityId) => selectedEntities.some((p) => p.entityId === entityId);

  const toggleSelection = (entity) => {
    const entityId = getEntityId(entity);
    const alreadySelected = isSelected(entityId);

    const normalizedEntity = {
      ...entity,
      entityId,
    };

    if (alreadySelected) {
      const updated = selectedEntities.filter((p) => getEntityId(p) !== entityId);
      onSelect(updated);
    } else {
      onSelect([...selectedEntities, normalizedEntity]);
    }
  };

  useEffect(() => {
    const fetchEntities = async () => {
      if (!profile?.id || !profile?.platform) return;
      setLoading(true);

      const [fromDate, toDate] = dateRange;
      const formattedFromDate = dayjs(fromDate).startOf("day").toISOString();
      const formattedToDate = dayjs(toDate).add(1, "day").startOf("day").toISOString();

      try {
        const response = await EntityService.fetchEntity(
          profile.platform,
          formattedFromDate,
          formattedToDate,
          [],
          profile.id
        );

        const rawEntities = Array.isArray(response) ? response : [response];

        const validEntities = rawEntities.filter((entity) => {
          if (["Facebook", "Instagram"].includes(profile.platform)) {
            return Array.isArray(entity.posts) && entity.posts.length > 0;
          } else if (profile.platform === "YouTube") {
            return Array.isArray(entity.videos) && entity.videos.length > 0;
          }
          return false;
        });

        setEntities(validEntities);
        setHeightCalculationDone(false);
        imageHeightsRef.current = [];
      } catch (error) {
        console.error("Failed to fetch entities:", error);
        setEntities([]);
      } finally {
        setLoading(false);
      }
    };

    fetchEntities();
  }, [profile, dateRange]);

  const [fromDate, toDate] = dateRange;
  const contentField = profile.platform === "YouTube" ? "videos" : "posts";

  const filteredEntities = entities
    .flatMap((entity) => (Array.isArray(entity[contentField]) ? entity[contentField] : []))
    .filter((item) => {
      const createdTime = item.created_time || item.publishedAt || item.taken_at;
      if (!createdTime) return false;
      const localTime = dayjs(createdTime);
      return (
        localTime.isSameOrAfter(dayjs(fromDate).startOf("day")) &&
        localTime.isSameOrBefore(dayjs(toDate).endOf("day")) &&
        (item.message || item.caption || item.title || "").toLowerCase().includes(searchQuery.toLowerCase())
      );
    })
    .sort((a, b) => new Date(b.created_time || b.publishedAt || b.taken_at) - new Date(a.created_time || a.publishedAt || a.taken_at));

  const forcedHeight = useMemo(() => {
    if (!heightCalculationDone) return null;
    const counts = {};
    imageHeightsRef.current.forEach((h) => {
      counts[h] = (counts[h] || 0) + 1;
    });
    const sorted = Object.entries(counts).sort((a, b) => b[1] - a[1]);
    const MAX_ALLOWED_HEIGHT = 300; // px

    return sorted.length > 0
      ? Math.min(Number(sorted[0][0]), MAX_ALLOWED_HEIGHT)
      : null;

  }, [heightCalculationDone]);

  return (
    <MDBox>
      <MDBox
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        sx={{
          position: "sticky",
          top: `${toolbarTop}px`,
          zIndex: 999,
          backgroundColor: "#ffffff",
          padding: "5px",
          borderRadius: "8px",
          gap: 2,
          mb: 5,
          boxShadow: isTransparent ? "none" : "0 4px 12px rgba(0, 0, 0, 0.2)",
          transition: "top 0.9s ease, background-color 0.9s ease, box-shadow 0.9s ease",
        }}
      >
        <ADSearch searchQuery={searchQuery} setSearchQuery={setSearchQuery} placeholder="Filter content by caption..." />
        <ADDateRange onDateChange={handleDateChange} />
      </MDBox>

      <Card sx={{ height: "calc(100vh - 310px)", display: "flex", flexDirection: "column" }}>
        <MDBox
          mx={2}
          mt={-3}
          py={1}
          px={2}
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="info"
          display="flex"
          flexDirection="row"
          alignItems="center"
        >
          <MDTypography variant="h6" color="white">
            {`Your ${profile.platform === "YouTube" ? "Videos" : "Posts"}`}
          </MDTypography>
          <CustomTooltip title={tooltipContent} placement="bottom" arrow>
            <IconButton sx={{ color: "white", p: 0, ml: 0.5 }}>
              <InfoOutlinedIcon fontSize="small" />
            </IconButton>
          </CustomTooltip>
        </MDBox>

        <MDBox px={2} py={3} sx={{ flexGrow: 1, overflowY: "auto" }}>
          {loading ? (
            <MDBox display="flex" justifyContent="center" alignItems="center" p={3}>
              <CircularProgress color="accent" />
            </MDBox>
          ) : filteredEntities.length === 0 ? (
            <MDTypography variant="subtitle1" color="text" align="center">
              No entities found for this profile.
            </MDTypography>
          ) : (
            <MDBox display="flex" flexWrap="wrap" justifyContent="center" gap={2} px={2} mt={0.5}>
              {filteredEntities.map((entity, index) => {
                const id = getEntityId(entity);
                const type = profile.platform === "YouTube" ? "video" : "post";

                return (
                  <Grow
                    in={true}
                    timeout={index * 50}
                    key={id}
                    style={{ transformOrigin: "0 0 0" }}
                  >
                    <MDBox
                      sx={{ flex: "1 1 calc(20% - 16px)", minWidth: "280px", maxWidth: "300px" }}
                    >
                      <EntityCard
                        entityObject={entity}
                        platform={profile.platform}
                        entityType={type}
                        profileObject={profile}
                        isSelected={isSelected(id)}
                        onSelect={() => toggleSelection(entity)}
                        forcedHeight={forcedHeight}
                        registerHeight={registerHeight}
                      />
                    </MDBox>
                  </Grow>
                );
              })}

            </MDBox>
          )}
        </MDBox>
      </Card>
    </MDBox>
  );
}

export default SelectEntity;
